import { render, staticRenderFns } from "./GrupaStatusaDetails.vue?vue&type=template&id=71163e97&scoped=true&"
import script from "./GrupaStatusaDetails.vue?vue&type=script&lang=js&"
export * from "./GrupaStatusaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71163e97",
  null
  
)

export default component.exports